import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import Select from "react-select";
import { forceInputUppercase } from "../../utils/helper";
import { createBreedCategory , updateBreedCategory } from "../../actions/breedCategory";

const $ = window.$;

class AddBreedCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            PetId: "",
            emailTemplateName : "",
            name : "",
            loading: false,
            inputNotValid: false,
            BreedCategoryId : null
          };      
}

  closeModal = () => {
    $("#add_breed_category").modal("hide");
    this.resetState();
    this.props.actionBreedCategory();
  };

  resetState = () => {
    this.setState({
        PetId: "",
        emailTemplateName : "",
        name : "",
        loading: false,
        inputNotValid: false ,
        BreedCategoryId : null
    });
  };

  submitBreedCategory(e) {
    this.setState({ loading: true });
    let data = {
        email_templatename: this.state.emailTemplateName,
        name : this.state.name,
        PetShopId: this.props.petShop.currentPetshop.id,
      };
      let valid = this.state.emailTemplateName.length > 0  && this.state.name.length > 0;
      if (valid) {
        if(this.state.BreedCategoryId){
          data.id = this.state.BreedCategoryId;
          this.props.updateBreedCategory(data); 
          this.props.actionBreedCategory();       
        }else{
          this.props.createBreedCategory(data);
        }      
      } else {
        e.preventDefault();
        NotificationManager.warning("Template name or name cannot be empty");
        this.setState({ loading: false , inputNotValid: true });
      }
  }

  handleChange = event => {
    forceInputUppercase(event);
    const value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  componentWillReceiveProps = nextProps => {
    
    if (nextProps.selectedBreedCategoryData 
            && nextProps.selectedBreedCategoryData.id
            && nextProps.selectedBreedCategoryData.id !== this.state.BreedCategoryId ) {    
             this.setState({
              BreedCategoryId : nextProps.selectedBreedCategoryData.id,
              emailTemplateName : nextProps.selectedBreedCategoryData.email_templatename,
              name : nextProps.selectedBreedCategoryData.name,
              }, () => {               
                $("#add_breed_category").modal("show");
             });
          }
      
    if (nextProps.breedCategory && this.props.breedCategory !== nextProps.breedCategory) {
      this.setState({ name: "", emailTemplateName : "", BreedCategoryId : null, loading: false });
      NotificationManager.success("Breed Category Added");
      $("#add_breed_category").modal("hide");
    }

    if (nextProps.breedCategoryUpdated && this.props.breedCategoryUpdated  !== nextProps.breedCategoryUpdated) {
      this.setState({ name: "", emailTemplateName : "", BreedCategoryId : null, loading: false });
      NotificationManager.success("Breed Category Updated");
      $("#add_breed_category").modal("hide");
    }

    if (nextProps.breedCategoryError && this.props.breedCategoryError !== nextProps.breedCategoryError) {
      if(nextProps.breedCategoryError.details.message && nextProps.breedCategoryError.details.message === 'Email template already exists')
       { 
         NotificationManager.error("Email template already exists"); 
        this.setState({loading : false});
       }
      else {
        NotificationManager.error("Failed to add email template."); 
        this.setState({  name: "", emailTemplateName : "",  loading: false });
        $("#add_breed_category").modal("hide");
      }     
    }

    if (nextProps.updateBreedCategoryError && this.props.updateBreedCategoryError !== nextProps.updateBreedCategoryError) {
      if(nextProps.updateBreedCategoryError.details.message && nextProps.updateBreedCategoryError.details.message === 'Email template already exists')
       { 
         NotificationManager.error("Email template already exists"); 
        this.setState({loading : false});
       }
      else {
        NotificationManager.error("Failed to add email template."); 
        this.setState({  name: "", emailTemplateName : "",  loading: false });
        $("#add_breed_category").modal("hide");
      }     
    }

  }

render() {
    const { PetId, toa } = this.state;
    return (
        <div
        className="modal fade show"
        id="add_breed_category"
        tabIndex="-1"
        role="dialog"
      >
           <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {!this.state.BreedCategoryId  ? "Add new welcome email template " : "Edit welcome email teplate"}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                    <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                             Name
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="name"                         
                            value={this.state.name}
                            onChange={e => this.handleChange(e)}
                            className="form-control m-input"
                            placeholder=""
                          />
                          <span
                            className={
                              this.state.inputNotValid && this.state.name.length === 0
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter name
                            </span>
                          </div>
                        </div>
                        <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                            Email Template 
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <input
                            type="text"
                            name="emailTemplateName"  
                            value={this.state.emailTemplateName}
                            onChange={e => this.handleChange(e)}                                                 
                            className="form-control m-input"
                            placeholder=""
                          />
                          <span
                            className={
                              this.state.inputNotValid && this.state.emailTemplateName.length === 0 
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter email template name
                            </span>
                          </div>
                        </div>
                       
                    </div>
                   </div>
                </div>
            </div>   
            <div className="modal-footer">
            {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                      </button>
                    <button
                      onClick={(e) => this.submitBreedCategory(e)}
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                      </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
            </div>     
        </form>
        </div>
        </div>
      </div>
    )
}

}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    breedCategory: state.breedCategoryReducer.setBreedCategory,
    breedCategoryError: state.breedCategoryReducer.setBreedCategoryError,
    breedCategoryUpdated : state.breedCategoryReducer.updateBreedCategory,
    updateBreedCategoryError : state.breedCategoryReducer.updateBreedCategoryError,
  });
  
  const mapDispatchToProps = dispatch => ({
    createBreedCategory: data => {
      dispatch(createBreedCategory(data));
    },

    updateBreedCategory: data => {
      dispatch(updateBreedCategory(data));
    },

  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddBreedCategory)
  );